// extracted by mini-css-extract-plugin
export default {"container":"closer_container__nKzgf","content":"closer_content__CEhIG"};